import { z } from 'zod'

// Case HTML Response Schema
export const CaselawReferenceHtmlResponseSchemaV3 = z.object({
  data: z.string(),
})
export type CaselawReferenceHtmlResponseV3 = z.infer<typeof CaselawReferenceHtmlResponseSchemaV3>

// Case Metadata Response Schema
export const CaselawReferenceMetadataResponseSchemaV3 = z.object({
  s3_path: z.string(),
  title: z.string(),
  citation: z.string(),
  bb_citation: z.string(),
  decide_date: z.string(), // ISO date
  jurisdiction_code: z.string(),
  parent_id: z.string(),
})

export type CaselawReferenceMetadataResponseV3 = z.infer<typeof CaselawReferenceMetadataResponseSchemaV3>
